import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import { getUserSession } from "../../../../core/util/core/Session";

function Form() {
    const profileFilter = chooseProfileFilter()

    const session = getUserSession();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const { id } = useParams();

    const path = '/accountingprojects/';
    const paths = {
        endpointSave: config.endpoints.backend + 'accountingprojects/save',
        endpointGetById: config.endpoints.backend + 'accountingprojects/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Projeto",
        labelTitleEdit: "Editar Projeto",
        labelTitleView: 'Visualizar Projeto'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                core_user_id: session.user.id
            },
            fields: [
                {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 6,
                    readOnly: true
                },
                {
                    name: 'despro',
                    type: 'text',
                    label: 'Projeto Contabil',
                    validations: {
                        required: false,
                    },
                    readOnly: true,
                    columnSize: 6
                },
                {
                    name: 'accounting_project_name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: false,
                        projectName: true
                    },
                    columnSize: 12
                },
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    readOnly: false
                },
            ],
            customValidators: {
                projectName: async (value, options, key, attributes) => {
                    const checkProjectName = async (value) => {
                      let post = { accounting_project_name: value };
                      post.pdc_accounting_project_id = id;
                      if (value.trim().length > 2) {
                        let response = await Fetch.post(config.endpoints.backend + 'accountingprojects/getbyaccountingprojectname', post);
                        if (response.id) {
                          return '^Este nome ja esta cadastrado para outro projeto!';
                        }
                      }
          
                      return "";
                    }
                    return checkProjectName(value);
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
